import { Directive, inject, Injector } from "@angular/core";
import { AbstractControl, NgControl, ValidationErrors, Validators } from "@angular/forms";

@Directive()
export class BaseInputComponentClass {

    public isLoading: boolean = false;
    public disabled: boolean = false;

    public parentControl: AbstractControl | null = null;

    public ngControl: NgControl | null = null;
    protected onChange = (_value: any) => { };
    protected onTouchedCallback = () => { };

    private injector = inject(Injector);

    constructor() {}

    //#region Initialization

    public ngOnInit(): void {
        this.initializeNgControl();
    }

    protected initializeNgControl(): void {
        this.ngControl = this.injector.get(NgControl, null);
    }

    //#endregion Initialization

    //#region ControlValueAccessor

    public registerOnChange(fn: (value: any) => void): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: () => void): void {
        this.onTouchedCallback = fn;
    }

    public setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    //#endregion ControlValueAccessor

    //#region State Getters

    public get touched(): boolean {
        return this.ngControl?.control?.touched ?? false;
    }

    public get hasErrors(): boolean {
        return this.touched && this.ngControl?.control?.errors != null;
    }

    public get required(): boolean {
        return this.ngControl?.control?.hasValidator(Validators.required) || false;
    }

    //#endregion State Getters

    //#region Validation

    public validate(control: AbstractControl): ValidationErrors | null {
        this.parentControl = control;
        return null;
    }

    //#endregion Validation

    //#region Event Handlers

    public onBlur(): void {
        this.onTouchedCallback();
    }

    //#endregion Event Handlers
}
